<template>
<div class="col-md-12 order-container">
  <el-collapse accordion>
            <el-collapse-item
              name="1"
              :title="$t('app.modules.orders.headers.search_order')"
              class="col-12"
            >

              <div class="row">

                <div :class="sizes">
                  {{ $t("app.modules.orders.headers.created_date") }}
                  <el-date-picker
                    v-model="dates_created"
                    type="daterange"
                    format="MM-dd-yyyy"
                    align="right"
                    :start-placeholder="$t('app.general.start_date')"
                    :end-placeholder="$t('app.general.end_date')"
                    
                  >
                  </el-date-picker>
                </div>

                <div :class="sizes">
                  {{ $t("app.modules.orders.headers.order_number") }}
                  <fg-input>
                    <el-input
                      type="search"
                      clearable

                      :placeholder='
                        $t("app.modules.orders.headers.order_number")
                      '
                      v-model="numer_pedido"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </fg-input>
                </div>
                <div :class="sizes">
                  {{ $t("app.modules.orders.headers.delivery_date") }}
                  <el-date-picker
                    v-model="b_fechaEntrega"
                    type="daterange"
                    format="MM-dd-yyyy"
                    align="right"
                    :start-placeholder="$t('app.general.start_date')"
                    :end-placeholder="$t('app.general.end_date')"
                    
                  >
                  </el-date-picker>
                </div>
                <div :class="sizes">
                  {{ $t("app.modules.orders.headers.purchase_order") }}
                  <fg-input>
                    <el-input
                      type="search"
                      clearable

                      :placeholder='
                        $t("app.modules.orders.headers.purchase_order")
                      '
                      v-model="b_ordenCompra"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </fg-input>
                </div>
                 <div :class="sizes">
                  {{  $t("app.modules.orders.headers.description") }}
                  <fg-input>
                    <el-input
                      type="search"
                      clearable

                      :placeholder='
                         $t("app.modules.orders.headers.description")
                      '
                      v-model="b_descripcionProducto"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </fg-input>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
      <div
      class="col-md-12 float-left"
      v-for="ped in queriedData"
      :key="ped.idDetallePedido"
      style="padding-top: 20px"
    >
      <card>
        <div class="row">
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.business_name") }}</b
            >:
            {{ ped.razonSocial }}
            <b>{{ $t("app.modules.orders.headers.delivery_address") }}</b
            >:
            {{ ped.detalles[0].direccionEntrega }}
          </div>
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.reference") }}</b
            >:
            {{ ped.idPedido }}
            <br />
            <b>{{ $t("app.modules.orders.headers.order_number") }}</b
            >:
            {{ ped.numPedidoSAP }}
            <br />
            <b>{{ $t("app.modules.orders.headers.status") }}</b
            >:
            {{ $t('app.modules.orders.status.'+ estadoPedido.get(ped.idEstadoPedido)) }}
          </div>
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.created_date") }}</b
            >:
            {{ ped.fechaCreacionPedido }}
            <br />
            <b>{{ $t("app.modules.orders.headers.auth_date") }}</b
            >:
            {{
              ped.fechaConfirmacionPedido != "1900-01-01"
                ? ped.fechaConfirmacionPedido
                : ""
            }}
          </div>
          <!--
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.salesman") }}</b
            >:
            <br />
            {{ ped.vendedor }}
          </div>
          -->
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.customer_service") }}</b
            >:
            <br />
            {{ ped.servicioCliente }}
          </div>
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.purchase_order") }}</b
            >:
            <br />
            {{ ped.ordenCompraCliente }}
          </div>
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.total") }}</b
            >:
            {{ ped.total | currencyFormat }}
            <br />
            <b>{{ $t("app.modules.orders.headers.money") }}</b
            >:
            {{ ped.moneda }}
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-sm-12 col-md-7 col-lg-7">
            <n-button type="secondary" @click.native="addNewClaim(ped)" class="btn btn-sm pull-right">
              {{ $t("app.modules.orders.web.new_claim") }}
            </n-button>

            <n-button type="primary" @click.native="addItem(ped.idPedido)" class="btn btn-sm pull-right">
              {{ $t("app.modules.orders.web.buy_again") }}
            </n-button>
            <n-button v-if="ped.ordenCompraFile" type="primary" @click.native="showFile(ped.ordenCompraFile)" class="btn btn-sm pull-right">
              {{ $t("app.modules.orders.web.show_file") }}
            </n-button>
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <el-collapse>
                    <el-collapse-item :title="$t('app.modules.orders.web.view_items')">
                        <el-table :data="ped.detalles" :lazy="true"
                                  cell-class-name="word-break-word"
                        >
                            <!--
                            <el-table-column
                                prop="imagenProducto"

                                min-width="110"
                            >
                                <template slot-scope="scope">
                                  <img style="min-width: 100%" :src="[server + scope.row.imagenProducto]" />
                                </template>
                            </el-table-column>
                            -->
                            <el-table-column
                                prop="codigoProducto"
                                min-width="100"
                            >
                                <template slot-scope="scope">
                                  <b class="txt-head">{{ $t("app.modules.products.headers.SAPCode") }}</b
                                    >:
                                    <br />
                                    {{ scope.row.codigoProducto }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                min-width="100"
                            >
                                <template slot-scope="scope">
                                  <b class="txt-head">{{ $t("app.modules.orders.headers.description") }}</b
                                    >:
                                    <br />
                                  <span v-if="$store.state.lang == 'es'">
                                      {{ scope.row.descripcionProducto }}
                                  </span>
                                  <span v-else-if="$store.state.lang == 'en'">
                                      {{ scope.row.descripcionProducto }}
                                  </span>
                                  <span v-else>
                                      {{ scope.row.descripcionProducto }}
                                  </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="cantidad"
                                min-width="70"
                            >
                                <template slot-scope="scope">
                                  <b class="txt-head">{{ $t("app.modules.orders.headers.quantity") }}: </b>
                                  <br />
                                    {{ scope.row.cantidad | numFormat }}
                                    &nbsp;
                                    {{ scope.row.unidadMedida }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                min-width="70"
                            >
                                <template slot-scope="scope">
                                  <b class="txt-head">{{ $t("app.modules.orders.headers.subtotal") }}</b>:
                                  <br/>
                                    {{ scope.row.total | currencyFormat }} &nbsp; {{ scope.row.moneda }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="fechaEntregaSolicitada"
                                min-width="100"
                            >
                                <template slot-scope="scope">
                                <b class="txt-head">{{ $t("app.modules.orders.headers.delivery_date") }}: </b>
                                <br/>
                                {{ scope.row.fechaEntregaSolicitada | moment("MM-DD-YYYY") }}
                                </template>
                            </el-table-column>
                            <!--
                            <el-table-column
                                prop="direccionEntrega"
                                min-width="150"
                            >
                                <template slot-scope="scope">
                                  <b class="txt-head">{{ $t("app.modules.orders.headers.delivery_address") }}: </b>
                                    <br/>
                                    {{ scope.row.direccionEntrega }}
                                </template>
                            </el-table-column>
                            -->
                            <el-table-column min-width="150">
                              <template slot-scope="scope">
                                <n-button
                                  type="primary"
                                  class="btn btn-sm"
                                  @click.native="showTracking(ped, scope.row)"
                                >
                                {{ $t("app.modules.orders.tracking.name") }}
                              </n-button>
                              <br/>
                              </template>
                              <template slot-scope="scope">
                                <n-button
                                  type="secondary"
                                  class="btn btn-sm btn-outline-secondary"
                                  @click.native="showDocs(scope.row)"
                                >
                                {{ $t("app.modules.orders.web.docs") }}
                              </n-button>
                              </template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
      </card>
    </div>
    <car-item-add />
</div>
</template>
<script>
import Vue from 'vue'
import ConstEstadoPedido from '@/models/pedidos/ConstEstadoPedido'
import { mapState, mapMutations } from "vuex";
import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'

Vue.filter('numFormat', numFormat(numeral))

export default {
  components: {
    CarItemAdd: () => import("../components/addAllItemsToCart"),
  },
  computed: {
    queriedData(){
      let result = this.applyFilters(this.datas)
      return result;
    },
    datas: function() {
      return this.pedidos.filter(
                (p) =>
                  p.idEstadoPedido == this.estadoPedido.ENTREGADO ||
                  p.idEstadoPedido == this.estadoPedido.DECLINADO ||
                  p.idEstadoPedido == this.estadoPedido.FINALIZADO
              );
    }
  },
  data() {
    return {
      sizes: "col-md-3 col-sm-6",
      estadoPedido: new ConstEstadoPedido(),
      server: "",
      detalles: [],
      //Valores para busqueda
      b_descripcionProducto: "",
      b_ordenCompra: "",
      b_fechaEntrega: "",
      b_razonSocial: "",
      dates_created: "",
      numer_pedido: ""
    };
  },
  created() {
      this.server = process.env.VUE_APP_API_ENDPOINT;
  },
  props: {
    pedidos: {
      type: Array,
      default: []
    }
  },
  methods: {
     showFile(fileItem){
          var url = this.server + fileItem.replace("//", "/");
          window.open(url, '_blank').focus();
    },
    applyFilters(result){

      //Busqueda de pedidos por numero pedido
     result =
        this.numer_pedido.length > 0
          ? result.filter(p =>
              p.numPedidoSAP.toLowerCase().includes(this.numer_pedido.toLowerCase())
            )
          : result;

       //Busqueda orden de compra
      result =
        this.b_ordenCompra.length > 0
          ? result.filter(p =>
              p.ordenCompraCliente.toLowerCase().includes(this.b_ordenCompra.toLowerCase())
            )
          : result;

      //Busqueda de pedidos por razon social
      result = this.b_razonSocial.length > 0
          ? result.filter(p =>
              p.razonSocial.toLowerCase().includes(this.b_razonSocial.toLowerCase())
            )
          : result;

      //Busqueda pedido por fecha de creacion
      result =
        (this.dates_created) && this.dates_created[0] > new Date("1900-01-01") &&
        this.dates_created[1] > new Date("1900-01-01") &&
        this.dates_created[0] instanceof Date &&
        this.dates_created[1] instanceof Date
          ? (result = result.filter(
              d =>
                new Date(d.fechaCreacionPedido) >= this.dates_created[0] &&
                new Date(d.fechaCreacionPedido) <= this.dates_created[1]
            ))
          : result;

      //Busqueda de descripcion
      result = this.b_descripcionProducto.length > 0
          ? result.filter(p =>
              p.detalles.find(
                det => (this.$store.state.lang == "es" ? det.descripcionProductoEs: det.descripcionProductoEn ).toLowerCase().includes(this.b_descripcionProducto.toLowerCase())
              )
            )
          : result;

      //Busqueda fecha de entrega
      result =(this.b_fechaEntrega) && this.b_fechaEntrega[0] > new Date("1900-01-01") &&
        this.b_fechaEntrega[1] > new Date("1900-01-01") &&
        this.b_fechaEntrega[0] instanceof Date &&
        this.b_fechaEntrega[1] instanceof Date
          ? result.filter(p => p.detalles.find( det =>  new Date(det.fechaEntregaSolicitada) >= this.b_fechaEntrega[0] && new Date(det.fechaEntregaSolicitada) <= this.b_fechaEntrega[1]))
          : result;

        return result;
    },
    PruebaClick(){
      console.log("Excelente está entrando")
    },
    createArray(item){
      console.log(item);
      var arrarReturn = new Array();
      arrarReturn.push(item);
      console.log(arrarReturn);
      return arrarReturn;
    },
    ...mapMutations({
      setOrder: "SET_ORDER",
      setDetail: "SET_DETAIL",
    }),
    addNewClaim(producto){
          EventBus.$emit("show-add-new-claim", producto);
    },
    addItem(id){
        EventBus.$emit("show-add.all-item-cart", id);
    },
    async showItems(id, tabRef) {

    var currTable = this.$refs[tabRef][0];
     const params = {
        id: parseInt(id),
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario
      };
      await this.$http.post(route("Pedidos/getPedidoDetalleWeb"), params)
      .then(
        async (response) => {
          if (response.body.code === 200) {
            this.detalles = response.body.detalles;
            this.$nextTick(function(){
              currTable.data = this.detalles;
            })
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
            console.error(response.body.message);
          }
        },
        (error) => {
          this.notifyMessage("danger", this.$t("app.promps.error"));
          console.error(error);
        }
      );
    },
    showTracking(pedido, detalle){
      // console.log(detalle);
      this.setOrder(pedido)
      this.setDetail(detalle)
      this.$router.push({name: "Tracking partida web"});
    },
    showDetail(id) {
      console.log(id);
      this.$router.push({
        name: "Detalle pedido web",
        params: { idPedido: id },
      });
    },
    showDocs(detalle){
      EventBus.$emit("partida-docs", { detallePedido: detalle });
    }
  },
  mounted() {

  },
  filters: {
    currencyFormat(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    }
  }
};
</script>
<style scoped>
.form-group .el-input__inner {
  padding: 10px 18px 10px 30px !important;
}
.ActiveLinkMethod {
       cursor: pointer;
    }
.txt-head{
  font-size: 0.8em;
}
</style>




